import moment from "moment";

const ItemStatus = {};

ItemStatus.getSmartlistStatus = (item) => {
  if (!item) return "";
  if (!item.enabled) return "stop";

  const today = moment();
  const hasTemporalRestriction = item.temporal_restriction;
  const begin_date = moment(item.begin_date);
  const end_date = moment(item.end_date);

  if (hasTemporalRestriction) {
    if (
      today.isBefore(begin_date) ||
      (!item.end_date && !today.isSameOrAfter(begin_date)) ||
      (item.end_date && !today.isBetween(begin_date, end_date))
    ) {
      return "pause";
    }
  }

  return "active";
};

ItemStatus.getAdvertisingStatus = (advertising) => {
  if (!advertising?.status) return "unknown";

  if (advertising.status === "enabled" && advertising.offers?.length < 1)
    return "paused";

  return advertising.status;
};

ItemStatus.getComponentStatus = (item, smartlist) => {
  if (!item) return "";
  if (!item.enabled) return "stop";

  if (
    (!item.static_component || !item.static_component.smartlist_module_name) &&
    (!item.dynamic_component ||
      !item.dynamic_component.smartlist_uuid ||
      ItemStatus.getSmartlistStatus(smartlist) !== "active")
  ) {
    return "pause";
  }

  return "active";
};

ItemStatus.getStatus = (item) => {
  if (!item) return "";
  if (!item.enabled) return "stop";

  return "active";
};

ItemStatus.getStatusByType = (item, type) => {
  let status = "";
  if (!item) return status;

  switch (type) {
    case "video":
      status =
        item.status === "archived" ? item.status : item.publication_status;
      break;
    case "smartlist":
    case "display":
      status = ItemStatus.getSmartlistStatus(item);
      break;
    case "casting":
      status = true;
      break;
  }

  return status;
};

ItemStatus.getEduStatus = (item) => {
  if (!item) return "";

  return item.status === "enabled" || item.status === "active"
    ? "active"
    : "stop";
};

ItemStatus.getOfferStatus = (item) => (item.enabled ? "active" : "stop");

export default ItemStatus;
